'use client';
import { useEffect, useRef, useState } from 'react';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { v4 as uuid } from 'uuid';
import { useBreakpoint } from '../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { MyEquipmentListItem } from '../my-equipment-list/my-equipment-list-item';
import { MyEquipmentVirtualScrollListProps } from '../types';
import { getDynamicHeight } from '../utils';
import { Conditional } from '../../common';
import { VirtualLoader } from './virtual-loader';
import styles from '../MyEquipment.module.scss';

export const MyEquipmentVirtualScrollList = ({
  list,
  onEquipmentSelect,
  searchTerm,
  selectedEquipment,
  children,
  isCustomerAccountSection
}: MyEquipmentVirtualScrollListProps) => {
  const reference = useRef<HTMLDivElement>(null);
  const [remainingHeight, setRemainingHeight] = useState(0);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  // here gapForScroll is used to give spacing between list cards and scroll coming from virtual list
  const gapForScroll = !isMD && !isCustomerAccountSection ? 'me-2' : '';
  const getItemSize = (index: number) => {
    const card = list[index];
    if (card?.assetId && card?.serialNumber) {
      return 114; //approximate static height given since itemSize is required in react window
      //dynamic height taken from blocks/react-window element obtained is wrong
    } else {
      return 110; //approximate static height given since itemSize is required in react window
    }
  };

  useEffect(() => {
    getDynamicHeight(reference, setRemainingHeight);
  }, [reference]);

  return (
    <div
      style={{
        height: isCustomerAccountSection
          ? '280px'
          : `calc(100vh - ${remainingHeight}px)`
      }}
      ref={reference}
    >
      <AutoSizer>
        {({ height, width }) => (
          <List
            height={height}
            itemData={list}
            itemCount={list.length}
            itemSize={getItemSize}
            width={width}
            key={uuid()}
            useIsScrolling
            className={styles['virtualized_wrapper_list']}
            direction="vertical"
          >
            {({ index, style, data, isScrolling }) => (
              <div style={style} data-testid="virtual-scroll-list">
                <Conditional
                  test={!isScrolling}
                  fallback={<VirtualLoader gapForScroll={gapForScroll} />}
                >
                  <MyEquipmentListItem
                    item={data[index]}
                    selectedEquipment={selectedEquipment}
                    onEquipmentSelect={onEquipmentSelect}
                    searchTerm={searchTerm}
                    isVirtualScroll
                    elementKey={uuid()}
                    gapForScroll={gapForScroll}
                  >
                    {children}
                  </MyEquipmentListItem>
                </Conditional>
              </div>
            )}
          </List>
        )}
      </AutoSizer>
    </div>
  );
};
